/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsCountry
 */
export interface MelcoModelsCountry {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountry
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountry
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsCountry
     */
    double_opt_in?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsCountry
     */
    default_currency_code?: string | null;
}

export function MelcoModelsCountryFromJSON(json: any): MelcoModelsCountry {
    return MelcoModelsCountryFromJSONTyped(json, false);
}

export function MelcoModelsCountryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsCountry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'double_opt_in': !exists(json, 'double_opt_in') ? undefined : json['double_opt_in'],
        'default_currency_code': !exists(json, 'default_currency_code') ? undefined : json['default_currency_code'],
    };
}

export function MelcoModelsCountryToJSON(value?: MelcoModelsCountry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'double_opt_in': value.double_opt_in,
        'default_currency_code': value.default_currency_code,
    };
}


